import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  Grid, TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button
} from '@material-ui/core';
import moment from 'moment'
import NumberFormat from 'react-number-format';
import isEmpty from 'lodash.isempty';
import 'react-calendar/dist/Calendar.css';
import '../../App.css'
import './style.css'
import { ProjectFunctionsAndFeeAction } from './ProjectsAction';
import numeral from 'numeral';
import 'numeral/locales/de'
import { DatePicker } from 'antd';
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import locale from 'antd/es/date-picker/locale/de_DE';


const dateFormat = 'DD.MM.YYYY';

class SecondTab extends Component {

  state = {
    projectId: '',
    travelrate: 0,
    travelrateSum: '',
    assistancerate: 0,
    assistanceSum: '',
    administrationrate: 0,
    adminSum: '',
    totalfees: '',
    totalnet: '',
    total: [],
    consultantList: [],
    startDate: '',
    endDate: '',
    costInfo: '',
    error: []
  }

  componentDidMount = () => {
    const { project_data } = this.props
    let { consultantList } = this.state;
    let travelSum, assistanceSum, adminrateSum
    let data = project_data.project_functions

    data.forEach(element => {
      consultantList.push({
        rowId: element.id,
        functionId: element.consultant_function_id,
        name: element.consultant_function,
        dailyRate: Number(element.dailyrate),
        days: Number(element.days),
        total: Number(element.sum)
      })
    });
    if (!isEmpty(project_data.travelrate)) {
      travelSum = ((Number(project_data.travelrate) * Number(project_data.totalfees)) / 100)
    }
    if (!isEmpty(project_data.administrationrate)) {
      adminrateSum = ((Number(project_data.administrationrate) * Number(project_data.totalfees)) / 100)
    }
    if (!isEmpty(project_data.assistancerate)) {
      assistanceSum = ((Number(project_data.assistancerate) * Number(project_data.totalfees)) / 100)

    }
    this.setState({
      consultantList,
      projectId: project_data.id,
      travelrate: Number(project_data.travelrate),
      assistancerate: Number(project_data.assistancerate),
      administrationrate: Number(project_data.administrationrate),
      endDate: project_data.enddate !== null ? moment(project_data.enddate).format("DD.MM.YYYY") : '',
      startDate: project_data.startdate !== null ? moment(project_data.startdate).format("DD.MM.YYYY") : '',
      totalfees: Number(project_data.totalfees),
      costInfo: project_data.addcostsinfo !== null ? project_data.addcostsinfo : '',
      totalnet: Number(project_data.totalnet),
      travelrateSum: Number(travelSum),
      adminSum: Number(adminrateSum),
      assistanceSum: Number(assistanceSum)
    })

  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { error_validation } = this.props;
    if (nextProps.error_validation !== error_validation) {
      this.setState({ error: nextProps.error_validation })
    }
  }

  createFunctionsAndFee = () => {
    const { ProjectFunctionsAndFeeAction, isBlockingCheckfalse } = this.props
    const dataObj = this.state;
    ProjectFunctionsAndFeeAction(dataObj)
    isBlockingCheckfalse()
  }

  handleChangeField = (e, index, field) => {
    numeral.locale('de');
    const { consultantList, travelrate, assistancerate, totalfees, administrationrate } = this.state
    let sum, travelSum, assistanceSum, adminrateSum, totalnetSum
    if (field === "dailyRate") {
      consultantList[index].dailyRate = numeral(e.target.value).value()
    } else if (field === "days") {
      consultantList[index].days = numeral(e.target.value).value()
    }
    if (consultantList[index].days && consultantList[index].dailyRate) {
      consultantList[index].total = (Number(consultantList[index].days) * Number(consultantList[index].dailyRate)).toFixed(2)
      const totalFee = consultantList.map(list => {
        if (list.total !== null)
          return Number(list.total)
        else
          return 0
      })
      sum = totalFee.reduce(function (a, b) {
        return a + b;
      }, 0);
      travelSum = ((numeral(travelrate).value() * sum) / 100).toFixed(2)
      assistanceSum = (((numeral(assistancerate).value() * sum) / 100)).toFixed(2)
      adminrateSum = (((numeral(administrationrate).value() * sum) / 100)).toFixed(2)
      totalnetSum = (sum + Number(travelSum) + Number(assistanceSum) + Number(adminrateSum)).toFixed(2)
    } else {

      const totalFee = consultantList.map(list => {
        if (list.total !== null)
          return Number(list.total)
        else
          return 0
      })
      sum = totalFee.reduce(function (a, b) {
        return a + b;
      }, 0);
      sum = Number(totalfees) - Number(consultantList[index].total)
      consultantList[index].total = ''
      travelSum = ((numeral(travelrate).value() * sum) / 100).toFixed(2)
      assistanceSum = (((numeral(assistancerate).value() * sum) / 100)).toFixed(2)
      adminrateSum = (((numeral(administrationrate).value() * sum) / 100)).toFixed(2)
      totalnetSum = (sum + Number(travelSum) + Number(assistanceSum) + Number(adminrateSum)).toFixed(2)
    }
    this.setState({
      consultantList,
      totalfees: sum,
      travelrateSum: travelSum,
      adminSum: adminrateSum,
      assistanceSum: assistanceSum,
      totalnet: totalnetSum
    }, () => this.props.isBlockingCheck())
  }

  travelHandleChange = (e) => {
    const { totalfees, adminSum, assistanceSum } = this.state
    let travelSum, netTotal
    if (totalfees !== '') {
      travelSum = ((Number(numeral(e.target.value).value()) * Number(totalfees)) / 100).toFixed(2)
    }
    if (!isNaN(travelSum)) {
      netTotal = Number(totalfees) + Number(isNaN(adminSum) ? 0 : adminSum) + Number(isNaN(assistanceSum) ? 0 : assistanceSum) + Number(travelSum)
    }
    else {
      netTotal = Number(isNaN(totalfees) ? 0 : totalfees) + Number(isNaN(adminSum) ? 0 : adminSum) + Number(isNaN(assistanceSum) ? 0 : assistanceSum)
      travelSum = 0
    }
    this.setState({ travelrateSum: travelSum, travelrate: e.target.value, totalnet: netTotal }, () => this.props.isBlockingCheck())
  }
  adminRateHandleChange = (e) => {
    const { totalfees, travelrateSum, assistanceSum } = this.state
    let adminrateSum, netTotal
    if (totalfees !== '') {
      adminrateSum = ((Number(numeral(e.target.value).value()) * Number(totalfees)) / 100).toFixed(2)
    }
    if (!isNaN(adminrateSum)) {
      netTotal = Number(isNaN(totalfees) ? 0 : totalfees) + Number(isNaN(travelrateSum) ? 0 : travelrateSum) + Number(isNaN(assistanceSum) ? 0 : assistanceSum) + Number(adminrateSum)
    } else {
      netTotal = Number(isNaN(totalfees) ? 0 : totalfees) + Number(isNaN(travelrateSum) ? 0 : travelrateSum) + Number(isNaN(assistanceSum) ? 0 : assistanceSum)
      adminrateSum = 0
    }
    this.setState({ adminSum: adminrateSum, administrationrate: e.target.value, totalnet: netTotal }, () => this.props.isBlockingCheck())
  }
  asistanceHandleChange = (e) => {
    const { totalfees, adminSum, travelrateSum } = this.state
    let assistSum, netTotal
    if (totalfees !== '') {
      assistSum = ((Number(numeral(e.target.value).value()) * Number(totalfees)) / 100).toFixed(2)
    }
    if (!isNaN(assistSum)) {
      netTotal = Number(isNaN(totalfees) ? 0 : totalfees) + Number(isNaN(travelrateSum) ? 0 : travelrateSum) + Number(assistSum)

    } else {
      netTotal = Number(isNaN(totalfees) ? 0 : totalfees) + Number(isNaN(travelrateSum) ? 0 : travelrateSum) + Number(isNaN(adminSum) ? 0 : adminSum)
      assistSum = 0
    }

    this.setState({ assistanceSum: assistSum, assistancerate: e.target.value, totalnet: netTotal }, () => this.props.isBlockingCheck())
  }
  render() {
    const { error, travelrate, costInfo, travelrateSum, assistancerate, assistanceSum, administrationrate, adminSum, totalfees, totalnet, consultantList, endDate, startDate } = this.state
    const access_rights = JSON.parse(localStorage.getItem('access_right'))
    const { forOther, forOwn, isBlockingCheck, isInactive } = this.props

    return (
      <div className={`${(Number(access_rights.projects_fee_for_other) !== 2 && forOther) || (Number(access_rights.projects_fee_for_own) !== 2 && forOwn && forOther) || (Number(access_rights.projects_fee_for_own) !== 2 && forOwn) ?
        "disableALlFields" : ""}`}>
        {!((Number(access_rights.projects_fee_for_other) !== 2 && forOther) || (Number(access_rights.projects_fee_for_own) !== 2 && forOwn)) &&
          <Button variant="outlined" color="primary" style={{ float: 'right' }} className="m-10" onClick={this.createFunctionsAndFee} >Speichern</Button>
        }
        <Grid container spacing={1}>
          <Grid item xs={6} style={{ paddingTop: '30px' }}>
            <Grid container spacing={1}>
              <Grid item xs={3} style={{ paddingTop: '10px', fontSize: '14px' }}>
                Projektbeginn
                            </Grid>
              <Grid item xs={9}>
                <DatePicker
                  className={!isEmpty(error.start_date) ? "errorClass" : ''}
                  locale={locale}
                  value={startDate === "" ? '' : moment(startDate, dateFormat)}
                  format={dateFormat}
                  placeholder="DD.MM.YYYY"
                  bordered={false}
                  disabled={isInactive}
                  onChange={(e) => {
                    if (!isEmpty(error.start_date))
                      error.start_date = []
                    if (e !== null) {
                      let date = moment(e._d).format("DD.MM.YYYY");
                      this.setState({ startDate: date }, () => isBlockingCheck())
                    } else {
                      this.setState({ startDate: "" }, () => isBlockingCheck())
                    }
                  }} />
                <br />
                {error.start_date &&
                  <div className="errorSpan">
                    <span>
                      {error.start_date}
                    </span>
                  </div>
                }
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={3} style={{ paddingTop: '10px', fontSize: '14px' }}>
                Ende
                            </Grid>
              <Grid item xs={9}>
                <DatePicker
                  locale={locale}
                  value={endDate === "" ? '' : moment(endDate, dateFormat)}
                  format={dateFormat}
                  placeholder="DD.MM.YYYY"
                  bordered={false}
                  disabled={isInactive}
                  onChange={(e) => {
                    if (e !== null) {
                      let date = moment(e._d).format("DD.MM.YYYY");
                      this.setState({ endDate: date }, () => isBlockingCheck())
                    } else {
                      this.setState({ endDate: "" }, () => isBlockingCheck())
                    }
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <Grid container spacing={1}>
              <Grid item xs={12} style={{ paddingTop: '0px', fontSize: '14px' }}>
                Nebenkosteninfo
                            </Grid>
              <Grid item xs={12} className="d-flex textarea-field textarea-field-2">
                <TextField required fullWidth multiline rows={5}
                  variant="outlined"
                  value={costInfo}
                  disabled={isInactive}
                  onChange={(e) => this.setState({ costInfo: e.target.value }, () => isBlockingCheck())}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <div className="projectTable tabsTableStyle">
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell width="45%">Beraterfunktion</TableCell>
                  <TableCell align="right">vertragl. Tage</TableCell>
                  <TableCell align="right">Tagessatz</TableCell>
                  <TableCell align="right">Summe</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {!isEmpty(consultantList) &&
                  consultantList.map((consultant, index) => (
                    <TableRow key={index}>
                      <TableCell width="45%">{consultant.name}</TableCell>
                      <TableCell align="center">
                        <NumberFormat
                          customInput={TextField}
                          className="rightToLeft"
                          inputProps={{
                            maxLength: 40
                          }}
                          variant="outlined"
                          value={consultantList[index].days}
                          thousandSeparator='.'
                          decimalSeparator=","
                          fixedDecimalScale={true}
                          decimalScale='2'
                          disabled={isInactive}
                          onChange={(e) => this.handleChangeField(e, index, "days")}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <NumberFormat
                          customInput={TextField}
                          className="rightToLeft"
                          inputProps={{
                            maxLength: 40
                          }}
                          variant="outlined"
                          value={consultantList[index].dailyRate}
                          thousandSeparator='.'
                          decimalSeparator=","
                          fixedDecimalScale={true}
                          decimalScale='2'
                          disabled={isInactive}
                          onChange={(e) => this.handleChangeField(e, index, "dailyRate")}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <NumberFormat
                          customInput={TextField}
                          className="rightToLeft"
                          required={true}
                          inputProps={{
                            maxLength: 40
                          }}
                          variant="outlined"
                          value={Number(consultantList[index].total)}
                          thousandSeparator='.'
                          decimalSeparator=","
                          fixedDecimalScale={true}
                          decimalScale='2'
                          disabled
                        />
                      </TableCell>
                    </TableRow>
                  ))
                }
                <TableRow>
                  <TableCell colSpan='3' align="right"><span className="rightsp">Summe Honorare</span></TableCell>
                  <TableCell align="center">
                    <NumberFormat
                      customInput={TextField}
                      className="rightToLeft"
                      inputProps={{
                        maxLength: 40
                      }}
                      disabled
                      variant="outlined"
                      value={totalfees}
                      thousandSeparator='.'
                      decimalSeparator=","
                      fixedDecimalScale={true}
                      decimalScale='2'
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan='3' align="right">
                    <div className="p-inner">
                      <span>Reisekosten</span>
                      <span>
                        <NumberFormat
                          customInput={TextField}
                          className="rightToLeft"
                          inputProps={{
                            maxLength: 40
                          }}
                          helperText={!isEmpty(error.travelrate) ? error.travelrate : ''} error={!isEmpty(error.travelrate) ? true : false}
                          variant="outlined"
                          value={travelrate}
                          thousandSeparator='.'
                          decimalSeparator=","
                          fixedDecimalScale={true}
                          decimalScale='2'
                          disabled={isInactive}
                          onChange={(e) => {
                            if (!isEmpty(error.travelrate))
                              error.travelrate = []
                            this.travelHandleChange(e)
                          }}
                        />
                      </span>
                      <span>%</span>
                      <span>=</span>
                    </div>
                  </TableCell>
                  <TableCell align="center">
                    <NumberFormat
                      customInput={TextField}
                      className="rightToLeft"
                      inputProps={{
                        maxLength: 40
                      }}
                      disabled
                      variant="outlined"
                      value={Number(travelrateSum)}
                      thousandSeparator='.'
                      fixedDecimalScale={true}
                      decimalSeparator=","
                      decimalScale='2'
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan='3' align="right">
                    <div className="p-inner">
                      <span>Assistenzkosten</span>
                      <span>
                        <NumberFormat
                          customInput={TextField}
                          className="rightToLeft"
                          inputProps={{
                            maxLength: 40
                          }}
                          variant="outlined"
                          helperText={!isEmpty(error.assistancerate) ? error.assistancerate : ''} error={!isEmpty(error.assistancerate) ? true : false}
                          value={assistancerate}
                          thousandSeparator='.'
                          decimalSeparator=","
                          fixedDecimalScale={true}
                          decimalScale='2'
                          disabled={isInactive}
                          onChange={(e) => {
                            if (!isEmpty(error.assistancerate))
                              error.assistancerate = []
                            this.asistanceHandleChange(e)
                          }}
                        />
                      </span>
                      <span>%</span>
                      <span>=</span>
                    </div>
                  </TableCell>
                  <TableCell align="center">
                    <NumberFormat
                      customInput={TextField}
                      className="rightToLeft"
                      inputProps={{
                        maxLength: 40
                      }}
                      disabled
                      variant="outlined"
                      value={Number(assistanceSum)}
                      thousandSeparator='.'
                      fixedDecimalScale={true}
                      decimalSeparator=","
                      decimalScale='2'
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan='3' align="right">
                    <div className="p-inner">
                      <span>Verwaltungskosten</span>
                      <span>
                        <NumberFormat
                          customInput={TextField}
                          className="rightToLeft"
                          inputProps={{
                            maxLength: 40
                          }}
                          helperText={!isEmpty(error.administrationrate) ? error.administrationrate : ''} error={!isEmpty(error.administrationrate) ? true : false}
                          variant="outlined"
                          value={administrationrate}
                          thousandSeparator='.'
                          decimalSeparator=","
                          fixedDecimalScale={true}
                          decimalScale='2'
                          disabled={isInactive}
                          onChange={(e) => {
                            if (!isEmpty(error.administrationrate))
                              error.administrationrate = []
                            this.adminRateHandleChange(e)
                          }}
                        />
                      </span>
                      <span>%</span>
                      <span>=</span>
                    </div>
                  </TableCell>
                  <TableCell align="center">
                    <NumberFormat
                      customInput={TextField}
                      className="rightToLeft"
                      inputProps={{
                        maxLength: 40
                      }}
                      disabled
                      variant="outlined"
                      value={Number(adminSum)}
                      thousandSeparator='.'
                      decimalSeparator=","
                      fixedDecimalScale={true}
                      decimalScale='2'
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan='3' align="right"><span className="rightsp">Gesamtsumme </span></TableCell>
                  <TableCell align="center">
                    <NumberFormat
                      customInput={TextField}
                      className="rightToLeft"
                      inputProps={{
                        maxLength: 40
                      }}
                      disabled
                      variant="outlined"
                      value={Number(totalnet)}
                      thousandSeparator='.'
                      decimalSeparator=","
                      fixedDecimalScale={true}
                      decimalScale='2'
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div >

    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    // dispatching actions
    ProjectFunctionsAndFeeAction: (data) => dispatch(ProjectFunctionsAndFeeAction(data)),
  }
}

export default connect(null, mapDispatchToProps)(SecondTab)